import React, { useEffect, useState, Fragment } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import { useParams, Link } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import CurrencyFormat from '../Helpers/Formatters/CurrencyFormat';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SvgIcon from '@material-ui/core/SvgIcon';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Card, CardContent, Typography, Box } from '@material-ui/core';
import './Account.scss';
import CustomerSupportPhone from './CustomerSupportPhone';
import { SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_COVR_FULLUW_KEY, getSessionStorageItem, getBasicInfo, SESSION_STORAGE_AMERICO_OBJECT_KEY } from '../../sessionStorage';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import PersonIcon from '@material-ui/icons/Person';
import SearchIcon from '@material-ui/icons/Search';
import MailIcon from '@material-ui/icons/Mail';
import BeachAccessIcon from '@material-ui/icons/BeachAccess';
import GetProductTypeEnum from '../../types/productType';
import { BestowHandoffUrl } from "../Quoters/Digital/Bestow/BestowApplyDialog";
import HavenApplyDialog from "../Quoters/Digital/Haven/HavenApplyDialog";
import IconHolder from "../Helpers/IconHolder";
import CalendarIcon from '../../icons/calendar.svg';
import ShieldIcon from '../../icons/home.svg';
import CrutchIcon from '../../icons/crutch.svg';

export default function Activity(props) {
  const useStyles = makeStyles(theme => ({
    buttonClass: {
      border: 'none',
      backgroundColor: 'inherit',
      float: 'right',
      color: theme.palette.primary.main,
    }
  }));

  const classes = useStyles();
  const { applicationId } = useParams();
  const [activitySummaryList, setActivitySummaryList] = useState([]);
  const [activeCaseStatus, setActiveCaseStatus] = useState(null);
  const [isCoverageModalOpen, setIsCoverageModalOpen] = useState(false);

  useEffect(() => {
    let activities = null;
    let inProgress = "";
    if (props.caseStatusList) {
      activities = props.caseStatusList.map((caseStatusItem, index) => <ActivitySummary key={index} caseStatus={caseStatusItem} />);
    }
    if (props.inProgressAppsList) {
      inProgress = props.inProgressAppsList.map((item, index) => <InProgressSummary key={index} inProgressItem={item} history={props.history} />);
    }

    if (activities) {
      setActivitySummaryList(
        <React.Fragment>
          {activities && activities.length > 0 &&
            <React.Fragment>
              <Row style={{ "width": "100%", "marginLeft": '0' }}>
                <Col xs={12} lg={12} className="order-1" >
                  Submitted Applications
                </Col>
              </Row>
              {activities}
            </React.Fragment>}
          {inProgress && inProgress.length > 0 &&
            <React.Fragment>
              <Row style={{ "width": "100%", "marginLeft": '0' }} >
                <Col xs={12} lg={12} className="order-1" >
                  Uncompleted Applications
                </Col>
              </Row >
              {inProgress}
            </React.Fragment>}
        </React.Fragment>);
    } else {
      setActivitySummaryList(<CircularProgress />);
    }

    if (applicationId && props.caseStatusList && props.caseStatusList.length) {
      setActiveCaseStatus(props.caseStatusList.find(cs => cs.ApplicationId === applicationId));
    } else {
      setActiveCaseStatus(null);
    }
  }, [props.caseStatusList, applicationId, props.inProgressAppsList]);

  return <Container>
    {activeCaseStatus ? <ActivityDetails caseStatus={activeCaseStatus} /> :
      <React.Fragment>
        <Row>
          <Col xs={12} className='mb-4'>
            <button onClick={() => { setIsCoverageModalOpen(true) }} className={classes.buttonClass}>
              <span className='ml-1 float-right'><b>ADD COVERAGE</b></span>
              <SvgIcon component={AddCircleOutlineIcon} className='float-right' color='primary' />
            </button>
          </Col>
        </Row>
        <Row className="activityList">{activitySummaryList}</Row>
        <CoverageDetailDialog
          show={isCoverageModalOpen}
          onHide={() => setIsCoverageModalOpen(false)}
        />
        </React.Fragment>}
  </Container>;
}

const CoverageDetailDialog = (props) => {

  const phoneNumber = CustomerSupportPhone();

  const cardList = [
    {
      icon: CalendarIcon,
      name: "TERM LIFE INSURANCE",
      href: "/landing/etrade-term",
    },
    // {
    //   icon: ShieldIcon,
    //   name: "LOAN PROTECTION",
    //   href: "/landing/loan-protector",
    // },
    // {
    //   icon: CrutchIcon,
    //   name: "DISABILITY INCOME",
    //   href: "/landing/disability-income",
    // },
  ]

  return (
    <Modal {...props} aria-labelledby="Coverage-modal" size="lg" className="coverage-modal">
      <Modal.Body className='p-0'>
        <Container className='p-0'>
          <Row className="no-gutters coverage-header">
            <div className='imageForCoverageModal'></div>
            <div class="headerDiv">
              <div className="coverage-text">New Coverage</div>
            </div>
            <Col className="text-right">
              <IconButton aria-label="close" className="closeButton" onClick={props.onHide}>
                <CloseIcon />
              </IconButton>
            </Col>
          </Row>
          <Row className='topClass'>
            <Col className='marginClass'>
              <div className='coverage-title'>Certain life events may trigger the need to purchase additional coverage, or even new coverage for a loved one.</div>
              <Row className="mt-3 card-alignment">
                {cardList.map((card, i) => (
                  <Col xs="auto" className="pr-0 pb-3 mt-3">
                    <Card className="card-vertical d-flex flex-column" variant="elevation" key={i}>
                      <CardContent className='pointerDiv' onClick={() => window.location.href = card.href}>
                        <div className="d-flex justify-content-center">
                          <IconHolder icon={card.icon} viewBox="0 0 25 25" />
                        </div>
                        <Typography variant="body1" component="div" align="center" className="mt-2 p-2">
                          <Box fontWeight="fontWeightBold" fontSize={15}>
                            {card.name}
                          </Box>
                        </Typography>
                      </CardContent>
                    </Card>
                  </Col>
                ))}
              </Row>
              <div class="mb-3 coverage-footer">
                If you need additional coverage AND have an application pending decision, please contact our team directly at &nbsp;
                <a href={`tel:${phoneNumber}`}>
                  {phoneNumber}
                </a>
                .
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};


const ActivitySummary = (props) => {

  const useStyles = makeStyles(theme => ({
    policy: {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
      border: '1px solid #CCCCCC',
      borderRadius: '6px',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      '&:not(:last-child)': {
        marginBottom: '1rem',
      },
      // marginLeft: '.5rem',
      // marginRight: '.5rem',
      width: '100%',
    },

    status: {
      marginBottom: 0,
      paddingBottom: 0,
      fontStyle: 'italic',
      fontSize: '14px',
      fontWeight: 500,
      color: '#5E6771',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    carrierProduct: {
      fontSize: '20px',
      marginBottom: 0,
      fontWeight: 500,
    },
    faceTerm: {
      fontSize: '16px',
      fontWeight: 500,
      marginBottom: 0,
    },
    premium: {
      fontSize: '26px',
      fontWeight: 700,
      marginBottom: 0,
    },
    perMonth: {
      fontSize: '19px',
      fontWeight: 300,
    },
    white: {
      backgroundColor: 'white',
    },
  }));

  const classes = useStyles();

  const AppStatusProgress = withStyles(() => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: "#E3E3E3",
    },
    bar: {
      borderRadius: 5,
      backgroundColor: props.caseStatus.ConsumerStatusColor,
    },
  }))(LinearProgress);

  return <Row className={classes.policy}>
    <Col xs={6} lg={2} md={2} className="order-1">
      <img className="img-fluid" src={props.caseStatus.CarrierLogoUrl} />
    </Col>
    <Col xs={6} lg={2} md={3} className="order-2 order-lg-3 priceAmount order-md-3">
      <p className={classes.premium}><CurrencyFormat number={props.caseStatus.Premium} /><span className={classes.perMonth}>/mo</span></p>
    </Col>
    <Col xs={12} lg={3} md={3} className="order-3 order-lg-2 order-md-2 carrierTerm">
      <p className={classes.carrierProduct}>{props.caseStatus.Product}</p>
      <p className={classes.faceTerm}><CurrencyFormat number={props.caseStatus.FaceAmount} whole /> - {props.caseStatus.TermLength} Year Term</p>
    </Col>
    <Col xs={6} lg={3} md={2} className="order-4">
      <p className={classes.status}>{props.caseStatus.Status}</p>
      <AppStatusProgress variant="determinate" value={props.caseStatus.ConsumerDetailStep * 20} myColor="black" />
    </Col>
    <Col xs={6} lg={2} md={2} className="order-5 btnView">
      <Button component={Link} to={`/account/activity/${props.caseStatus.ApplicationId}`} variant="contained" color="primary">
        View <Chip label={"1"} size="small" className={classes.white + " ml-1"} clickable />
      </Button>

    </Col>
  </Row>
}

const useStylesBaseActivity = makeStyles(theme => ({
  status: {
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
    border: '1px solid #CCCCCC',
    borderRadius: '6px',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    '&:not(:last-child)': {
      marginBottom: '1rem',
    },
  },
}));

const StatusFinished = (props) => {
  const baseActivityStyle = useStylesBaseActivity();

  const useStyles = makeStyles(theme => ({
    finished: {
      backgroundColor: '#FFFFFF',
      marginLeft: '25px',
      marginRight: '25px',
    },
    progressChip: {
      color: 'white',
      backgroundColor: '#30B81E',
    }
  }));
  const classes = useStyles();

  return <Fragment>
    <Row className={`${baseActivityStyle.status} ${classes.finished}`}>
      <Col className="col-auto">
        {props.icon}

        <KeyboardArrowRightIcon />

        {props.title}
      </Col>

      <Col className="col-auto ml-auto">
        <Chip label={"COMPLETE"} size="small" className={classes.progressChip} />
      </Col>
    </Row>
  </Fragment>
}

const StatusCurrent = (props) => {
  const baseActivityStyle = useStylesBaseActivity();


  const useStyles = makeStyles(theme => ({
    currentStatus: {
      backgroundColor: props.caseStatus.ConsumerStatusColor,
    }
  }));
  const classes = useStyles();
  const [applyHavenUrl, setApplyHavenUrl] = useState(null);

  return <Fragment>
    <Row className={`${classes.currentStatus} ${baseActivityStyle.status}`}>
      <Col className="col-auto">
        {props.icon}

        <KeyboardArrowDownIcon />

        {props.title}
      </Col>
      <Col className="col-auto ml-auto">
        <Chip label={props.caseStatus.ConsumerDetailStep < 5 ? "IN PROGRESS" : "COMPLETE"} size="small" />

      </Col>
    </Row>
    <CurrentStatusInfo setApplyHavenUrl={(js) => setApplyHavenUrl(js)} caseStatus={props.caseStatus} />
    <div>
      {applyHavenUrl}
    </div>
  </Fragment>
}

const StatusFuture = (props) => {
  const baseActivityStyle = useStylesBaseActivity();

  const useStyles = makeStyles(theme => ({
    futureStatus: {
      backgroundColor: '#FFFFFF',
      marginLeft: '25px',
      marginRight: '25px',
      '& span': {
        color: '#999999',
      }
    }
  }));

  const classes = useStyles();
  return <Fragment>
    <Row className={`${baseActivityStyle.status} ${classes.futureStatus}`}>
      <Col>
        {props.icon}

        <KeyboardArrowRightIcon />

        <span>{props.title}</span>
      </Col>
    </Row>
  </Fragment>
}

const ActivityDetails = (props) => {

  const useStyles = makeStyles(theme => ({
    status: {
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
      border: '1px solid #CCCCCC',
      borderRadius: '6px',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      '&:not(:last-child)': {
        marginBottom: '1rem',
      },
    },
    mainStatus: {
      backgroundColor: '#FFFFFF',
    },
    doneStatus: {
      backgroundColor: '#FFFFFF',
      marginLeft: '25px',
      marginRight: '25px',
    },
    futureStatus: {
      backgroundColor: '#FFFFFF',
      marginLeft: '25px',
      marginRight: '25px',
      'stepTitle': {
        color: 'red',
      }
    }
  }));

  const classes = useStyles();

  const AppStatusProgress = withStyles(() => ({
    colorPrimary: {
      backgroundColor: props.caseStatus.ConsumerStatusBackgroundColor,
    },
    bar: {
      backgroundColor: props.caseStatus.ConsumerStatusColor,
    },
  }))(LinearProgress)

  return (props.caseStatus == null) ? <CircularProgress /> :
    <div>
      <Link to="/account/activity">Back</Link>

      <Row>
        <Col>
          <img className="img-fluid" src={props.caseStatus.CarrierLogoUrl} />
        </Col>
        <Col>
          {props.caseStatus.Product} {' '}
          <CurrencyFormat number={props.caseStatus.FaceAmount} whole />
        </Col>
        <Col>
          {<CurrencyFormat number={props.caseStatus.Premium} />}/mo

        </Col>
      </Row>

      <Row className={`${classes.status} ${classes.mainStatus}`}>
        <Col>
          <p>{props.caseStatus.ConsumerPlatformStatusTracker}</p>
          Step {props.caseStatus.ConsumerDetailStep} of 5

          <AppStatusProgress value={props.caseStatus.ConsumerDetailStep * 20} variant="determinate" />
          {props.caseStatus.ConsumerPlatformStatusTracker}
        </Col>
      </Row>

      {props.caseStatus.ConsumerDetailStep > 1 && <StatusFinished caseStatus={props.caseStatus} title="Quoting Coverage" icon={<DesktopWindowsIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 1 && <StatusCurrent caseStatus={props.caseStatus} title="Quoting Coverage" icon={<DesktopWindowsIcon />} />}

      {props.caseStatus.ConsumerDetailStep > 2 && <StatusFinished caseStatus={props.caseStatus} title="Completing Application" icon={<PersonIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 2 && <StatusCurrent caseStatus={props.caseStatus} title="Completing Application" icon={<PersonIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 2 && <StatusFuture caseStatus={props.caseStatus} title="Completing Application" icon={<PersonIcon />} />}

      {props.caseStatus.ConsumerDetailStep > 3 && <StatusFinished caseStatus={props.caseStatus} title="Application Review" icon={<SearchIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 3 && <StatusCurrent caseStatus={props.caseStatus} title="Application Review" icon={<SearchIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 3 && <StatusFuture caseStatus={props.caseStatus} title="Application Review" icon={<SearchIcon />} />}

      {props.caseStatus.ConsumerDetailStep > 4 && <StatusFinished caseStatus={props.caseStatus} title="Policy Delivery" icon={<MailIcon />} />}
      {props.caseStatus.ConsumerDetailStep === 4 && <StatusCurrent caseStatus={props.caseStatus} title="Policy Delivery" icon={<MailIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 4 && <StatusFuture caseStatus={props.caseStatus} title="Policy Delivery" icon={<MailIcon />} />}

      {props.caseStatus.ConsumerDetailStep === 5 && <StatusCurrent caseStatus={props.caseStatus} title={props.caseStatus.ConsumerPlatformStatusTracker !== "Closed" ? "Coverage Active" : "Coverage Inactive"} icon={<BeachAccessIcon />} />}
      {props.caseStatus.ConsumerDetailStep < 5 && <StatusFuture caseStatus={props.caseStatus} title={props.caseStatus.ConsumerPlatformStatusTracker !== "Closed" ? "Coverage Active" : "Coverage Inactive"} icon={<BeachAccessIcon />} />}

    </div>

}

const CurrentStatusInfo = (props) => {
  const useStyles = makeStyles(theme => ({
    currentStatus: {
      backgroundColor: props.caseStatus.ConsumerStatusBackgroundColor,
      border: '2px solid ' + props.caseStatus.ConsumerStatusColor,
      marginTop: '-0.75rem',
      marginBottom: '1rem',
      paddingTop: '1rem',
    }
  }));

  const classes = useStyles();
  var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const isHavenSI = accountObj.accountProducts.some(function (item) {
    return item.productTypeId === GetProductTypeEnum().HavenSI;
  });

  const redirectToSite = () => {
    let quoteLogReqObj = JSON.parse(props.caseStatus.QuoteLogRequest);
    let quoteLogObj = JSON.parse(props.caseStatus.QuoteLogResponse);
    let newQuoteFields = quoteLogReqObj;
    newQuoteFields.stateOfResidence = quoteLogReqObj.State;
    newQuoteFields.tobacco = quoteLogReqObj.Tobacco == 'true' ? 'yes' : 'no';
    newQuoteFields.healthClass = quoteLogReqObj.HealthClass;
    newQuoteFields.coverageAmount = quoteLogReqObj.CoverageAmount;
    newQuoteFields.termLength = quoteLogReqObj.CoverageLength;
    newQuoteFields.email = quoteLogReqObj.Email;
    newQuoteFields.phone = quoteLogReqObj.Phone;
    newQuoteFields.birthdate = quoteLogReqObj.BirthDate;
    newQuoteFields.gender = quoteLogReqObj.Gender;
    if (props.caseStatus.Carrier === 'Haven') {
      props.setApplyHavenUrl(<HavenApplyDialog
        simpleIssue={isHavenSI}
        hideForm={true}
        quoteFields={newQuoteFields}
        selectedQuote={quoteLogObj}
        sessionId={accountObj.sessionId}
      />)
    }
    else {
      let response
      fetch(`/api/ConsumerApplication/GetConsumerDetails?consumerApplicationId=${props.caseStatus.ConsumerApplicationId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      })
        .then(res => res.json())
        .then((data) => {
          response = data;
        })
        .then(() => {
          newQuoteFields.height = response.pages.aboutMe.height;
          newQuoteFields.weight = response.pages.aboutMe.weight;
          window.location = BestowHandoffUrl(newQuoteFields, quoteLogObj);
        }
        ).catch((error) => { console.log(error) });
    }
  }

  return (
    <Row className={classes.currentStatus}>
      <Col>
        <p>{props.caseStatus.Status}</p>
        {
          (props.caseStatus.Carrier === 'Haven' || props.caseStatus.Carrier === 'Bestow' && props.caseStatus.Status==="Completing Application") ?
            <div>
              <p>Hang tight!  Your case status will update in the next 24 hours.  If there is a chance that you have not fully submitted your application <button className="linkButton" onClick={() => { redirectToSite() }}>click here</button> to pick up where you left off.</p>
            </div>
            :
            <p>{props.caseStatus.ConsumerWhatsNext}</p>
        }
      </Col>
    </Row>
  )
}

const InProgressSummary = (props) => {
  //const [loading, setLoading] = useState(false);
  //const [message, setMessage] = useState('');
  const retrieveProgress = (consumerApplicationId) => {
    fetch('api/ConsumerApplication/SSOGet?AppId=' + consumerApplicationId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.appData !== null && data.appData.includes('currentStep')) {
          let jsonRes = JSON.parse(data.appData);
          if(jsonRes.steps && jsonRes.steps.quoter.product === 'Americo'){
            const SESSION_STORAGE_KEY = "AMERICO_QUOTE";
            sessionStorage.setItem(SESSION_STORAGE_KEY, data.appData);
            jsonRes.mctFlowData ? sessionStorage.setItem(SESSION_STORAGE_COVR_FULLUW_KEY,JSON.stringify(jsonRes.mctFlowData)) : null;
            jsonRes.mctQuoterData ? sessionStorage.setItem(SESSION_STORAGE_AMERICO_OBJECT_KEY,JSON.stringify(jsonRes.mctQuoterData)) : null;
            props.history.push(`/quote/term-life-insurance/loan-protector`);
          }
          else{
            sessionStorage.setItem(SESSION_STORAGE_COVR_FULLUW_KEY, data.appData);
            props.history.push(`/quote/term-life-insurance/multi-carrier-term/`);
          }
        } else {
          //setMessage('No progress was found.');
        }
        //setLoading(false);
      });
  }

  const useStyles = makeStyles(theme => ({
    policy: {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)',
      border: '1px solid #CCCCCC',
      borderRadius: '6px',
      paddingTop: '1rem',
      paddingBottom: '1rem',
      '&:not(:last-child)': {
        marginBottom: '1rem',
      },
      width: '100%',
    },
    status: {
      marginBottom: 0,
      paddingBottom: 0,
      fontStyle: 'italic',
      fontSize: '14px',
      fontWeight: 500,
      color: '#5E6771',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    carrierProduct: {
      fontSize: '20px',
      marginBottom: 0,
      fontWeight: 500,
    },
    faceTerm: {
      fontSize: '16px',
      fontWeight: 500,
      marginBottom: 0,
    },
    premium: {
      fontSize: '33px',
      fontWeight: 700,
      marginBottom: 0,
    },
    perMonth: {
      fontSize: '19px',
      fontWeight: 300,
    }
  }));

  const classes = useStyles();

  const AppStatusProgress = withStyles(() => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: "#E3E3E3",
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#24A81B',
    },
  }))(LinearProgress);

  return <Row className={classes.policy}>
    <Col xs={6} lg={2} md={2} className="order-1" >
      <img className="img-fluid" src="/logos/covr-logo.svg" />
    </Col>
    <Col xs={6} lg={2} md={3} className="order-2 order-lg-3 priceAmount order-md-3">

    </Col>
    <Col xs={12} lg={3} md={3} className="order-3 order-lg-2 order-md-2 carrierTerm">
      <p className={classes.carrierProduct}>Term Application</p> {props.inProgressItem.createdDate}
    </Col>
    <Col xs={6} lg={3} md={2} className="order-4">
      <p className={classes.status}>Application Progress</p>
      <AppStatusProgress variant="determinate" value={props.inProgressItem.progressPercent} />
    </Col>
    <Col xs={6} lg={2} md={2} className="order-5 btnContinue">
      <Button onClick={() => retrieveProgress(props.inProgressItem.consumerApplicationId)} variant="contained" color="primary">
        Continue
      </Button>
    </Col>
  </Row>
}



// WEBPACK FOOTER //
// ./src/components/Account/Activity.js